export default {
    computed: {
        exporting(){
            return this.$store.state.exporting
        }
    },

    methods: {
        export(id = false){
            let params = []

            if(this.excelExportType == 'invoices'){
                if(!_.isNull(this.dateRange) && this.dateRange.length == 2){
                    params.push(`fromDate=${moment(this.dateRange[0]).format('YYYY-MM-DD')}`)
                    params.push(`toDate=${moment(this.dateRange[1]).format('YYYY-MM-DD')}`)
                }
                /* else if(_.has(this.$route.meta, 'dateRangeFilter') && !_.isNull(this.$store.state.dateRange)){
                    params.push(`fromDate=${moment(this.$store.state.dateRange[0]).format('YYYY-MM-DD')}`)
                    params.push(`toDate=${moment(this.$store.state.dateRange[1]).format('YYYY-MM-DD')}`)
                }*/

                if (this.exportType) {
                    params.push(`exportType=${this.exportType}`)

                    if (this.exportType === 'snelstart') {
                        params.push(`snelstart=${JSON.stringify(this.snelstart)}`)
                    }
                }

                // Always send type parameter
                params.push(`type=${this.transactionType}`)

                // Always send BTW percentage parameter
                params.push(`btwPercentage=${this.btwPercentage}`)

                params.push(`paid=${this.paid}`)

                if(this.user.role == 'pit'){
                    params.push(`organisation=${this.$store.state.dataBelongsTo}`)
                }
            }

            if(id){
                params.push(`id=${id}`)
            }

            params = params.join('&')

            axios.get(`/api/${this.excelExportType}/export?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                window.open('/export/'+response.data.token, '_blank')
            }).catch((e) => {
                console.error(e)
            }).then(() => {
                this.loading = false
                this.fullpageLoading = false
                this.$store.commit('startExport', false)
            })
        }
    },

    watch: {
        exporting(newVal){
            if(!!newVal){
                this.loading = true
                this.fullpageLoading = true
                this.export(_.has(newVal, 'id') ? newVal.id : false)
            }
        }
    }
}